import script from "./QuestionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionList.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionList.vue?vue&type=style&index=0&id=b3339096&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3339096"]])

export default __exports__